// packages/content/src/strings/news.ts (M1-T17) — keys are the NewsKind values (Contract change 8); {name} = the actor's name
import type { StringBank } from '../schema/strings';
export default {
  'town.founded': '{name:cap} founded {townName}. Everyone, wipe your feet.',
  'resident.arrived': '{name:cap} moved in. Go say hello.',
  'resident.left': '{name:cap} moved away.',
  'villager.arrived': '{name:cap} moved in with a lot of boxes.',
  'villager.left': '{name:cap} packed up and moved on to make room.',
  'fish.rare': '{name:cap} caught {fishName:a} ({size} cm)!',
  'museum.donation': '{name:cap} gave the museum {itemName:a}.',
  'museum.hallComplete': 'The {hall} at the museum is complete!',   // {hall} is 'fossil hall' or 'aquarium'
  'loan.paidOff': '{name:cap} paid off their home loan.',
  'house.upgraded': "{name:cap}'s house is now {levelName:a}.",
  'mayor.changed': '{name:cap} is the new mayor.',
  title: 'Town news', empty: 'Quiet day. Nothing new yet.', more: 'Older news', board: 'Town board',
  justNow: 'just now', minutesAgo: '{n} min ago', hoursAgo: '{n} h ago', daysAgo: '{n} {n|day|days} ago',
} as const satisfies StringBank;
